import { createWlinkI18n } from "@wlink/commons/i18n";
import { ref } from "vue";
const i18n = createWlinkI18n();
const { t } = i18n.global;

// tab支持语言 'ar', 'de', 'es', 'fil', 'fr', 'hi', 'id', 'it', 'ja', 'ko', 'ms', 'pt', 'ru', 'th', 'tr', 'vi',
export const supportedLangs = ["en", "zh-CN", "zh-TW"] as const;
type LangCode =
  | "zh-CN"
  | "zh-TW"
  | "en"
  | "ar"
  | "de"
  | "es"
  | "fil"
  | "fr"
  | "hi"
  | "id"
  | "it"
  | "ja"
  | "ko"
  | "ms"
  | "pt"
  | "ru"
  | "th"
  | "tr"
  | "vi";

const langList = ref<Record<LangCode, string>>({
  "zh-CN": t("65329"), // 简体中文
  "zh-TW": t("65330"), // 繁体中文
  en: t("65331"), // 英文
  ar: "阿拉伯语", // 阿拉伯语
  de: "德语", // 德语
  es: "西班牙语", // 西班牙语
  fil: "菲律宾语", // 菲律宾语
  fr: "法语", // 法语
  hi: "印度语", // 印度语
  id: "印尼语", // 印尼语
  it: "意大利语", // 意大利语
  ja: "日语", // 日语
  ko: "韩语", // 韩语
  ms: "马来语", // 马来语
  pt: "葡萄牙语", // 葡萄牙语
  ru: "俄罗斯语", // 俄罗斯语
  th: "泰语", // 泰语
  tr: "土耳其语", // 土耳其语
  vi: "越南语", // 越南语
});
export const getLangLabel = (lang: string) => {
  if (lang in langList.value) {
    return langList.value[lang as LangCode];
  }
  return lang;
};
